import React from 'react';

import DataTableAverage from '../DataTable/DataTableAverage';
import DataTableGrouped from '../DataTable/DataTableGrouped/DataTableGrouped';
import DataTableRange from '../DataTable/DataTableRange';
import { DATA_RANGE_TYPE } from '../Widget/constants';
import { useWidgetContext } from '../Widget/WidgetContext';

interface Props {
  data: any;
  valueDisplay?: number;
  comparisonTypeEnabled?: boolean;
}

const GraphWidgetContentTable = ({ data }: Props) => {
  const { rangeType } = useWidgetContext();

  return (
    <>
      {rangeType === DATA_RANGE_TYPE.NOW && <DataTableAverage data={data} />}
      {rangeType === DATA_RANGE_TYPE.OVERTIME && <DataTableRange data={data} />}
      {rangeType === DATA_RANGE_TYPE.GROUPED && <DataTableGrouped data={data} />}
    </>
  );
};

export default GraphWidgetContentTable;
